import {useState} from 'external/react'
import {
  clsx,
  Box,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Table
} from 'external/material'

import LinkBehavior from 'components/LinkBehavior'
import HomeworksHead from './HomeworksHead'
import useHomework from 'hooks/homework'
import useTranslations from 'hooks/translations'
import useSession from 'hooks/session'

import { isAfter } from 'external/date-fns'

import Timer from 'components/Timer'

export default function Homewokrs() {

  const {groupId, navigation} = useSession()
  const {formatDateTime,  translate} = useTranslations()
  const {homeworks} = useHomework()
  
  const [readyHomeworks, setReady] = useState({})

  return (
    <Box className="homeworks">
      <TableContainer className="homeworksTableContainer">
        <Table stickyHeader className="homeworksTable">
          <HomeworksHead includeActions={false} />
          <TableBody>
            {homeworks.map((homework, i) => {

              const ready = !!readyHomeworks[homework.id] || (isAfter(new Date(), homework.start))

              const to = groupId && navigation.homework.link({homeworkId: homework.id})
              return (<TableRow key={i}>
                <TableCell className="titleCell" align="left">
                  <span className={clsx("title")}>{homework.title}</span>
                </TableCell>
                <TableCell padding="none" align="left"><span className={"start"}>{formatDateTime(homework.start)}</span></TableCell>
                <TableCell padding="none" align="left"><span className={"finish"}>{formatDateTime(homework.finish)}</span></TableCell>
                <TableCell padding="none" align="left"><span className={clsx("statusName", homework.status)}>{translate(`homework-status-${homework.status}`)}</span></TableCell>
                <TableCell padding="none" align="center"><span className={"points"}>{homework.studentPoints || '-'} / {homework.points}</span></TableCell>
                <TableCell className="availability-cell" padding="none" align="center">
                    <Box className="view-homework-wrapper">
                      <Box className="view-homework-container">
                        {ready && to && (<Box to={to} component={LinkBehavior} className="view-homework-link">{translate('view')}</Box>)}
                        {!ready && <Timer className="homework-countdown" startsAt={homework.start} onExpiration={() => setReady({...readyHomeworks, [homework.id]: true})} />}
                      </Box>
                    </Box>
                </TableCell>          
              </TableRow>)
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}